import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "opacity-75 fixed inset-0 z-50 bg-white" }, null, -1)
const _hoisted_2 = { class: "fixed z-50 inset-0 flex flex-col justify-center items-center" }
const _hoisted_3 = { class: "text-gray-700 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MLoadingIcon = _resolveComponent("MLoadingIcon")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_MLoadingIcon),
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.loadText), 1)
    ])
  ], 64))
}